import React, { useState } from "react";
import Navbar from "./Navbar";
import { supabase } from "./supabase";

export default function Register() {
  const [step, setStep] = useState(1);
  const [employed, setEmployed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [form, setForm] = useState({ name: "", surname: "", email: "", phone: "", id: "", password: "", province: "", skills: [] });

  const provinces = ["Gauteng", "Western Cape", "KwaZulu-Natal", "Eastern Cape", "Limpopo", "Mpumalanga", "North West", "Free State", "Northern Cape"];
  const skillsList = ["Construction", "Coding", "Teaching", "Farming", "Accounting", "Driving", "Nursing", "Design", "Electrician", "Plumbing", "Carpentry", "Marketing"];

  const handleSkill = (skill) => {
    setForm(prev => ({
      ...prev,
      skills: prev.skills.includes(skill) ? prev.skills.filter(s => s !== skill) : [...prev.skills, skill]
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");
    const { error: signUpError } = await supabase.auth.signUp({
      email: form.email,
      password: form.password,
      options: {
        data: {
          first_name: form.name,
          last_name: form.surname,
          phone: form.phone,
          id_number: form.id,
          province: form.province,
          employment_status: employed,
          skills: form.skills,
        }
      }
    });
    setLoading(false);
    if (signUpError) {
      setError(signUpError.message);
    } else {
      setSuccess(true);
    }
  };

  const inputStyle = {
    width: "100%",
    background: "#F5F0E8",
    border: "1.5px solid #EDE8DF",
    borderRadius: 8,
    padding: "11px 14px",
    color: "#1A1A2E",
    fontSize: 16,
    fontFamily: "var(--font-body)",
    outline: "none",
    marginBottom: 14,
    boxSizing: "border-box",
  };

  const labelStyle = {
    fontSize: 11,
    color: "#888",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: 6,
    display: "block",
  };

  if (success) {
    return (
      <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh" }}>
        <Navbar />
        <div style={{ maxWidth: 520, margin: "0 auto", padding: "80px 24px", textAlign: "center" }}>
          <div style={{ width: 72, height: 72, background: "#1B3A6B", borderRadius: 18, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px" }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 900, color: "#1A1A2E", marginBottom: 12, letterSpacing: "-0.02em" }}>
            You're in, <span style={{ color: "#1B3A6B" }}>{form.name}</span>!
          </h1>
          <p style={{ color: "#888", fontSize: 15, lineHeight: 1.7 }}>
            Check your email to confirm your account, then come back to log in.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>

      <style>{`
        .reg-wrap { max-width: 520px; margin: 0 auto; padding: 56px 24px; }
        .reg-card { background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 32px; }
        @media (max-width: 480px) {
          .reg-wrap { padding: 32px 16px; }
          .reg-card { padding: 24px 20px; border-radius: 16px; }
        }
      `}</style>

      <Navbar />

      <div className="reg-wrap">

        {/* HEADER */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ width: 56, height: 56, background: "#1B3A6B", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2C8 6 6 10 8 14c-2-1-3-3-3-5C3 13 2 17 5 20c1.5 1.5 3.5 2 6 2 5 0 8-3 8-7 0-2-1-4-2.5-5.5C16 11 15 13 13 14c1-3 0-7-1-12z"/>
            </svg>
          </div>
          <h1 style={{ fontSize: 26, fontWeight: 900, color: "#1A1A2E", margin: "0 0 6px", letterSpacing: "-0.02em" }}>
            Join the <span style={{ color: "#1B3A6B" }}>Movement</span>
          </h1>
          <p style={{ color: "#888", fontSize: 13 }}>One account. Contribute. Find opportunity.</p>
        </div>

        {/* PROGRESS */}
        <div style={{ display: "flex", gap: 8, marginBottom: 32 }}>
          {[1, 2, 3].map((s) => (
            <div key={s} style={{ flex: 1, height: 4, borderRadius: 99, background: step >= s ? "#1B3A6B" : "#EDE8DF", transition: "background 0.3s" }} />
          ))}
        </div>

        {/* STEP 1 */}
        {step === 1 && (
          <div className="reg-card">
            <div style={{ fontSize: 17, fontWeight: 800, color: "#1A1A2E", marginBottom: 20 }}>Personal Information</div>
            {[
              { label: "First Name", key: "name", placeholder: "Ayanda" },
              { label: "Last Name", key: "surname", placeholder: "Dlamini" },
              { label: "Email Address", key: "email", placeholder: "ayanda@email.com" },
              { label: "Phone Number", key: "phone", placeholder: "071 234 5678" },
              { label: "SA ID Number", key: "id", placeholder: "9901015009087" },
            ].map((field) => (
              <div key={field.key}>
                <label style={labelStyle}>{field.label}</label>
                <input
                  type="text"
                  placeholder={field.placeholder}
                  value={form[field.key]}
                  onChange={(e) => setForm({ ...form, [field.key]: e.target.value })}
                  style={inputStyle}
                />
              </div>
            ))}
            <label style={labelStyle}>Province</label>
            <select
              value={form.province}
              onChange={(e) => setForm({ ...form, province: e.target.value })}
              style={inputStyle}
            >
              <option value="">Select your province</option>
              {provinces.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
            <button
              onClick={() => setStep(2)}
              style={{ width: "100%", background: "#1B3A6B", border: "none", borderRadius: 99, padding: "14px", color: "#fff", fontWeight: 700, fontSize: 15, cursor: "pointer", fontFamily: "var(--font-body)", marginTop: 8 }}
            >
              Continue
            </button>
          </div>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <div className="reg-card">
            <div style={{ fontSize: 17, fontWeight: 800, color: "#1A1A2E", marginBottom: 6 }}>Are you currently employed?</div>
            <p style={{ fontSize: 13, color: "#888", marginBottom: 20, lineHeight: 1.6 }}>This helps us connect you with the right opportunities on Forge SA.</p>

            {[
              { value: "yes", label: "Yes, I am employed", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg> },
              { value: "no", label: "No, I am looking for opportunities", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg> },
              { value: "self", label: "Self employed / Freelance", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8 6 6 10 8 14c-2-1-3-3-3-5C3 13 2 17 5 20c1.5 1.5 3.5 2 6 2 5 0 8-3 8-7 0-2-1-4-2.5-5.5C16 11 15 13 13 14c1-3 0-7-1-12z"/></svg> },
            ].map((opt) => (
              <div
                key={opt.value}
                onClick={() => setEmployed(opt.value)}
                style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 18px", background: employed === opt.value ? "rgba(27,58,107,0.06)" : "#F5F0E8", border: `1.5px solid ${employed === opt.value ? "#1B3A6B" : "#EDE8DF"}`, borderRadius: 10, cursor: "pointer", marginBottom: 10 }}
              >
                <div style={{ width: 36, height: 36, background: "#fff", border: "1px solid #EDE8DF", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  {opt.icon}
                </div>
                <span style={{ fontSize: 14, fontWeight: 600, color: employed === opt.value ? "#1B3A6B" : "#4A4A6A" }}>{opt.label}</span>
              </div>
            ))}

            {employed === "no" && (
              <div style={{ marginTop: 16, padding: 16, background: "rgba(46,125,50,0.06)", border: "1px solid rgba(46,125,50,0.15)", borderRadius: 10 }}>
                <div style={{ fontSize: 12, color: "#2E7D32", fontWeight: 700, marginBottom: 12 }}>
                  Your profile will be added to our talent database!
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {skillsList.map(skill => (
                    <button
                      key={skill}
                      onClick={() => handleSkill(skill)}
                      style={{ background: form.skills.includes(skill) ? "#1B3A6B" : "#fff", border: `1.5px solid ${form.skills.includes(skill) ? "#1B3A6B" : "#EDE8DF"}`, borderRadius: 99, padding: "6px 14px", color: form.skills.includes(skill) ? "#fff" : "#4A4A6A", fontSize: 12, cursor: "pointer", fontFamily: "var(--font-body)" }}
                    >
                      {skill}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
              <button
                onClick={() => setStep(1)}
                style={{ flex: 1, background: "transparent", border: "1.5px solid #EDE8DF", borderRadius: 99, padding: "13px", color: "#888", fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}
              >
                Back
              </button>
              <button
                onClick={() => setStep(3)}
                style={{ flex: 2, background: "#1B3A6B", border: "none", borderRadius: 99, padding: "13px", color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}
              >
                Continue
              </button>
            </div>
          </div>
        )}

        {/* STEP 3 */}
        {step === 3 && (
          <div className="reg-card">
            <div style={{ fontSize: 17, fontWeight: 800, color: "#1A1A2E", marginBottom: 20 }}>Create Your Password</div>

            <label style={labelStyle}>Password</label>
            <input
              type="password"
              placeholder="Create a strong password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              style={inputStyle}
            />

            {error && (
              <div style={{ background: "rgba(192,57,43,0.07)", border: "1px solid rgba(192,57,43,0.2)", borderRadius: 8, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "#C0392B" }}>
                {error}
              </div>
            )}

            <div style={{ display: "flex", gap: 10, alignItems: "flex-start", background: "rgba(46,125,50,0.06)", border: "1px solid rgba(46,125,50,0.15)", borderRadius: 10, padding: "14px 18px", marginBottom: 20 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 1 }}>
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              <span style={{ fontSize: 13, color: "#2E7D32", lineHeight: 1.6 }}>
                Your SA ID is used only to verify you are a real South African. We never sell your data. Ever.
              </span>
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{ width: "100%", background: loading ? "#EDE8DF" : "#1B3A6B", border: "none", borderRadius: 99, padding: "14px", color: loading ? "#888" : "#fff", fontWeight: 800, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", fontFamily: "var(--font-body)", marginBottom: 10 }}
            >
              {loading ? "Creating your account..." : "Join Forge SA"}
            </button>
            <button
              onClick={() => setStep(2)}
              style={{ width: "100%", background: "transparent", border: "1.5px solid #EDE8DF", borderRadius: 99, padding: "12px", color: "#888", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "var(--font-body)" }}
            >
              Back
            </button>
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 13, color: "#888" }}>
          Already have an account?{" "}
          <span
            onClick={() => window.location.href = "/login"}
            style={{ color: "#1B3A6B", fontWeight: 600, cursor: "pointer" }}
          >
            Sign In
          </span>
        </div>

      </div>
    </div>
  );
}